<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3691_190259)">
<rect x="4.14893" y="5.23749" width="1.28363" height="10.269" fill="#BBDAF3"/>
<path d="M7.9998 0.530945L4.14893 5.23651H5.43461L9.28343 0.530945H7.9998Z" fill="#D8ECFE"/>
<path d="M5.43359 5.23757V15.5066L9.28384 10.7999V0.530945L5.43359 5.23757Z" fill="#E6F2FE"/>
<path d="M10.5667 0.530945L6.71582 5.23651H8.00151L11.8503 0.530945H10.5667Z" fill="#D8ECFE"/>
<path d="M9.28349 9.17828L5.43262 13.8839H6.7183L10.5671 9.17828H9.28349Z" fill="#AAAAAA"/>
<rect x="5.43262" y="13.8839" width="1.28363" height="1.62267" fill="#888888"/>
<rect x="6.71582" y="5.23749" width="1.28363" height="10.269" fill="#BBDAF3"/>
<path d="M8.00049 5.23757V15.5066L11.8507 10.7999V0.530945L8.00049 5.23757Z" fill="#E6F2FE"/>
<path d="M4.14893 5.23644V15.5066H7.9998L11.8494 10.7999V0.530945H10.5671L9.28343 2.11075V0.530945H7.9998L4.14893 5.23644Z" stroke="black"/>
<path d="M4.14893 5.23749H5.43255" stroke="black" stroke-width="0.5"/>
<path d="M5.43213 13.8839H6.71575" stroke="black" stroke-width="0.5"/>
<path d="M6.71484 5.23749H7.99847" stroke="black" stroke-width="0.5"/>
<path d="M5.43359 15.5067V5.23757L9.28447 0.530945" stroke="black" stroke-width="0.5"/>
<path d="M7.99902 15.5067V5.23757L11.8499 0.530945" stroke="black" stroke-width="0.5"/>
<path d="M6.71484 15.5067V5.23757L10.5657 0.530945" stroke="black" stroke-width="0.5"/>
<path d="M5.44385 13.9042L6.71765 12.3217" stroke="black" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_3691_190259">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
